module.exports = __webpack_public_path__ + "fonts/KaTeX_Size3-Regular.4de844d4.woff";